import { forwardRef } from 'react';

import SidebarImage from './Image';

import APP from 'constants/app';
import LINKS from 'constants/links';

const CommunityNewFeaturesRequestsFeedback = forwardRef(({ ...props }, ref) => (
  <SidebarImage
    target="_blank"
    alt="Ajude a construir a maior comunidade de Promoções!"
    ref={ref}
    href={LINKS.NEW_FEATURES}
    src={`${APP.LOCAL_IMAGE_PATH}/banner/banner-new-features.jpg`}
    display={['none', null, null, null, 'block']}
    imageProps={{
      height: 'auto',
      width: 304,
      sizes: '(max-width: 1280px) 1px, 300px',
      srcSet: `${APP.LOCAL_IMAGE_PATH}/general/placeholder.jpg 1w, ${APP.LOCAL_IMAGE_PATH}/banner/banner-new-features.jpg 300w`,
    }}
    {...props}
  />
));

CommunityNewFeaturesRequestsFeedback.displayName =
  'CommunityNewFeaturesRequestsFeedback';

export default CommunityNewFeaturesRequestsFeedback;
